import { Link } from '@gsa/afp-component-library';
import { formatPhoneNumber } from '../../../../../ReviewDetails/RequisitionDetailsUtils';

export default function AreqDetailsContact({ title, contact }) {
    return (
        <div className="areq-details-contact">
            <strong className="title">{title}</strong>
            <div className='areq-details-contact-info'>
                <div>{contact.name}</div>
                <div><Link to={`mailto:${contact.email}`}>{contact.email}</Link></div>
                <div>{formatPhoneNumber(contact.phone.country, contact.phone.number, contact.phone.extension)}</div>
            </div>
        </div>
    )
}